import {createReducer} from '@reduxjs/toolkit'
import {Tabs} from '../../../../commons/enums'
import {setTab} from '../actions/events'

const defaultState = Tabs.UPCOMING as Tabs

export const tab = createReducer(defaultState, builder => {
  builder.addCase(setTab, (_, action) => action.payload)
})
